<template>
  <div class="home">
    <div style="padding-top: 20px;" class="carousel_container">
      <el-carousel arrow="never" trigger="click" :height="carouselHeight">
        <el-carousel-item v-for="(image, index) in carouselImages" class="carouselImg" :key="index">
          <el-image :src="image" alt="Carousel Image" fit="cover" class="carousel-image"></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="question">
      <div class="title">核心优势</div>
      <div class="question_content">
        <div class="question_content_center">
          <div class="app-wrapper">
            <div class="container">
              <div :style="{ gridTemplateColumns: gridTemplateColumns }" class="menu-grid">
                <div v-for="(item, index) in menuItemsWithHoverCopy" :style="{
                    background: item.type === 'hover' ? ` url(${item.hoverImage})` : `url(${item.backgroundImage})`,
                    backgroundBlendMode: item.type === 'hover' ? 'multiply' : 'normal', // 如果 type 为 hover，使用混合模式
                    height: '450px',
                    backgroundSize: item.type === 'hover' ? 'cover' : '100% 100%' // 如果 type 为 hover，背景大小为 cover
                  }" :key="index" class="menu-item group"
                  :class="{ 'highlight': (index < menuItems.length ? item : menuItems[hoveredIndex]).highlight }"
                  @mouseenter="handleMouseEnterWithDelay($event, index)" @mouseleave="handleMouseLeave">
                  <div class="menu-content">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 系统介绍模块 -->
    <div class="system-introduction">
      <h2 class="system-intro-title">系统介绍</h2>
      <div class="system-intro-content">
        <div class="system-intro-subtitle">
          中小型医疗机构的理想之选
        </div>
        <div class="system-intro-description">
          在医疗数智化转型浪潮中，中小型医疗机构急需提升运营效率与服务质量。克里特·易康医疗诊所综合运营管理系统，正是为此量身打造，
          系统融合现代信息技术，构建医疗与行政一体化管理体系全面覆盖医疗与行政两大关键领域，巧妙地将繁琐的工作流程化繁为简。从预约挂号到患者随访，优化就医全流程，提升服务质量。同时，整合医疗与行政管理功能，实现信息实时共享、业务协同，助力精准分析数据、优化资源配置，推动诊所数智化升级。
        </div>
      </div>
    </div>
    <weChart />
  </div>
</template>

<script>
import weChart from '../../../components/WeChart/index.vue'
export default {
  data() {
    return {
      scrollPosition: 0,
      hoveredIndex: -1,
      hoverTimeout: null,
      carouselHeight: '500px',
      // 新增：定义图片数组
      carouselImages: [
        require('@/assets/homeBanner4.png'),
        require('@/assets/homeBanner1.png'),
        require('@/assets/homeBanner2.png'),
      ],
      menuItems: [
        {
          title: '挂号 / 候诊',
          icon: 'fas fa-calendar-check',
          highlight: true,
          alerts: '患者可以通过微信、电话、官网等多种方式在线预约挂号系统会根据医生的排班情况自动分配号源',
          // 新增：背景图配置
          backgroundImage: require('@/assets/bghe1.png'),
          hoverImage: require('@/assets/bghe11.png'),
        },
        {
          title: '行政办公',
          icon: 'fas fa-briefcase',
          highlight: true,
          alerts: '流程优化、资源合理配置和快速响应确保工作顺畅进行规范则强调制度完善、操作标准化和职责明确',
          // 新增：背景图配置
          hoverImage: require('@/assets/bghe22.png'),
          backgroundImage: require('@/assets/bghe2.png')
        },
        {
          title: '运营数据',
          icon: 'fas fa-chart-line',
          highlight: true,
          alerts: '即时收集、处理与反馈，确保决策者能够迅速获取最新信息。所有操作和流程透明，便于监督和评估',
          // 新增：背景图配置
          hoverImage: require('@/assets/bghe33.png'),
          backgroundImage: require('@/assets/bghe3.png')
        },
        {
          title: '营销管理',
          icon: 'fas fa-bullhorn',
          highlight: true,
          alerts: '生成营销数据分析 报表，提供各项指 标，帮助管理者了 解营销活动的效果 及时调整营销策略',
          // 新增：背景图配置
          hoverImage: require('@/assets/bghe44.png'),
          backgroundImage: require('@/assets/bghe4.png')
        },
        {
          title: '药品进销存',
          icon: 'fas fa-pills',
          highlight: true,
          alerts: '实时监控药品库存, 自动提醒采购人员, 及时补充药品',
          // 新增：背景图配置
          hoverImage: require('@/assets/bghe55.png'),
          backgroundImage: require('@/assets/bghe5.png')
        },
        {
          title: '数据安全',
          icon: 'fas fa-shield-alt',
          highlight: true,
          alerts: '通过各项技术手段确保数据的机密性完整性和可用性，对数据生命周期的完全掌控确保数据始终在可控范围内',
          // 新增：背景图配置
          hoverImage: require('@/assets/bghe66.png'),
          backgroundImage: require('@/assets/bghe6.png')
        }
      ],
      advantageItems: [
        {
          title: '挂号/候诊',
          icon: require('@/assets/预警.png'),
          highlight: true
        },
        {
          title: '行政办公',
          icon: require('@/assets/管理.png'),
          highlight: true
        },
        {
          title: '运营数据',
          icon: require('@/assets/数据统计.png'),
          highlight: true,
          highlightText: '实时监控药品库存 自动提醒采购人员 及时补充药品'
        },
        {
          title: '营销管理',
          icon: require('@/assets/客户.png'),
          highlight: true
        },
        {
          title: '药品进销存',
          icon: require('@/assets/库存管理.png'),
          highlight: false
        },
        {
          title: '数据安全',
          icon: require('@/assets/安全保障.png'),
          highlight: true
        }
      ],
      // 新增判断是否为 1080p 屏幕的变量
      is1080p: window.innerWidth === 1920 && window.innerHeight === 1080
    }
  },
  mounted() {
    window.addEventListener('scroll', () => {
      this.scrollPosition = window.scrollY;
    });
    // 监听窗口大小变化，更新 is1080p 变量
    window.addEventListener('resize', () => {
      this.is1080p = window.innerWidth === 1920 && window.innerHeight === 1080;
      this.updateCarouselHeight();
    });

    // 初始化设置轮播图高度
    this.updateCarouselHeight();
  },
  computed: {
    gridTemplateColumns() {
      return this.is1080p ? 'repeat(auto-fit, 132px)' : 'repeat(auto-fit, minmax(100px, 1fr))';
    },

    menuItemsWithHoverCopy() {
      if (this.hoveredIndex === -1) {
        return this.menuItems;
      }
      const newMenuItems = [...this.menuItems];
      let data = {
        ...this.menuItems[this.hoveredIndex],
        type: 'hover'
      }
      // 在鼠标悬浮的菜单项后面插入一个相同的项
      newMenuItems.splice(this.hoveredIndex + 1, 0, data);
      // 打印新数组
      console.log(newMenuItems, '=======');
      // 创建一个新的数组引用，确保 Vue 能检测到变化
      // 优化：使用 Vue.set 确保响应式更新
      const reactiveNewMenuItems = [];
      newMenuItems.forEach((item, index) => {
        this.$set(reactiveNewMenuItems, index, item);
      });
      return reactiveNewMenuItems;
    }
  },
  methods: {
    updateCarouselHeight() {
      // 根据屏幕宽度调整轮播图高度
      if (window.innerWidth <= 480) {
        this.carouselHeight = '200px';
      } else if (window.innerWidth <= 768) {
        this.carouselHeight = '300px';
      } else {
        this.carouselHeight = '500px';
      }
    },
    handleMouseEnterWithDelay(event, index) {
      if (this.hoverTimeout) {
        clearTimeout(this.hoverTimeout); // 清除之前的定时器
      }
      this.hoverTimeout = setTimeout(() => {
        // 优化：确保 index 在 menuItems 范围内
        if (index < this.menuItems.length) {
          this.hoveredIndex = index;
          // 记录鼠标位置
          this.mouseX = event.clientX;
          this.mouseY = event.clientY;
          // 重新计算鼠标位置对应的菜单项索引
          this.recalculateHoveredIndex();
        }
      }, 100); // 设置 500 毫秒的延时，可根据需要调整
    },
    handleMouseLeave() {
      if (this.hoverTimeout) {
        clearTimeout(this.hoverTimeout); // 清除定时器
      }
      this.hoveredIndex = -1;
    },
    recalculateHoveredIndex() {
      const menuItems = document.querySelectorAll('.menu-item');
      menuItems.forEach((item, index) => {
        const rect = item.getBoundingClientRect();
        if (
          this.mouseX >= rect.left &&
          this.mouseX <= rect.right &&
          this.mouseY >= rect.top &&
          this.mouseY <= rect.bottom
        ) {
          this.hoveredIndex = index;
        }
      });
    }
  },
  components: {
    weChart
  }
}
</script>

<style lang="scss" scoped>
.home {
@media screen and (max-width: 768px) {
  .question_content{
    display: none;
  }
  .carouselImg{
    height: 100% !important;
  }
  .carousel-image {
    height: 100% !important;
  }
}
  // 系统介绍模块样式
  .system-introduction {
    padding: 100px 0;
    background: linear-gradient(135deg, rgb(206, 204, 252) 0%, #fff8f2 30%, #fff8f2 100%);

    .system-intro-title {
      font-family: 'MiSans', 'Source Han Sans CN', sans-serif;
      font-weight: 500;
      font-size: 32px;
      color: #252E3E;
      text-align: center;
      margin-bottom: 40px;
      font-style: normal;
      text-transform: none;
    }

    .system-intro-content {
      max-width: 800px;
      margin: 0 auto;
      padding: 40px;
      background-color: #FFFFFF;
      border: 1px dashed #E5E5E5;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);

      .system-intro-subtitle {
        font-family: 'MiSans', 'Source Han Sans CN', sans-serif;
        font-weight: 500;
        font-size: 20px;
        color: #252E3E;
        text-align: center;
        margin-bottom: 30px;
        line-height: 1.4;
      }

      .system-intro-description {
        font-family: 'MiSans', 'Source Han Sans CN', sans-serif;
        font-weight: 400;
        font-size: 16px;
        color: #252E3E;
        line-height: 1.8;
        text-align: justify;
        text-indent: 2em;
      }
    }
  }

  /* 添加媒体查询，优化移动端样式 */
  @media (max-width: 768px) {
    .carousel_container {
      width: 100%;

      .el-carousel {
        height: auto !important;
      }
    }

    .system-introduction {
      padding: 30px 15px;

      .system-intro-title {
        font-size: 24px;
        margin-bottom: 25px;
      }

      .system-intro-content {
        padding: 25px 20px;
        margin: 0 10px;

        .system-intro-subtitle {
          font-size: 18px;
          margin-bottom: 20px;
        }

        .system-intro-description {
          font-size: 14px;
          line-height: 1.6;
          text-indent: 1.5em;
        }
      }
    }
  }

  .carousel_container {
    width: 100%;
    overflow: hidden;

    .carousel-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }

    .carouselImg{
      width: 100%;
      height: 100%;
    }

    .carousel_bg_img1 {
      height: 100%;
      position: relative;
      overflow: hidden;

      .banner-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 auto;
        padding: 0 2rem;
        height: 100%;

        .banner-left {
          flex: 1;

          .banner-subtitle {
            font-size: 1.5rem;
            color: #4a90e2;
            margin-bottom: 1rem;
          }

          .banner-title {
            font-size: 2.5rem;
            font-weight: bold;
            color: #2c3e50;
            margin-bottom: 1rem;
            line-height: 1.2;
          }

          .banner-description {
            font-size: 1.2rem;
            color: #666;
          }
        }

        .banner-right {
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;

          .animated-icon {
            width: 300px;
            height: 300px;
            background-size: contain;
            background-repeat: no-repeat;
            animation: float 3s ease-in-out infinite;
          }
        }
      }
    }

    .carousel_bg_img2 {
      height: 100%;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .bg_img2_container {
        padding-top: 2rem;
        padding-left: 3.6rem;
        width: 90%;
        height: 38%;
        color: #376ccd;

        .top {
          font-size: 2rem;
          font-weight: 600;
          margin-bottom: 1.2rem;
        }

        .middle {
          font-size: 1rem;
        }
      }
    }

    .carousel_bg_img3 {
      height: 100%;
      background-image: url('../../../assets/homeBanner3.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }

  .question {
    padding-top: 2.4rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: linear-gradient(135deg, rgb(206, 204, 252) 0%, #fff8f2 30%, #fff8f2 100%);

    .title {
      font-family: 'MiSans';
      font-weight: 500;
      font-size: 32px;
      color: #252E3E;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }

    .subtitle {
      font-size: 0.56rem;
      color: #999999;
      margin-bottom: 2.4rem
    }

    .question_content {
      width: 100%;

      .question_content_top {
        display: flex;
        justify-content: space-between;
        margin-bottom: 0.4rem;

        .question_content_top_inside {
          width: 14%;
          padding: 0.8rem 0.8rem 0.4rem 0.8rem;
          border: 0.04rem solid #E5E5E5;

          .title {
            font-weight: 600;
            font-size: 0.72rem;
            margin-bottom: 0.4rem;
          }

          .bg_img {
            margin-bottom: 0.4rem;
            width: 4.4rem;
            height: 0.2rem;
            background-image: url('../../../assets/rectangle.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
          }

          .content {
            height: 4rem;
            line-height: 1rem;
            font-size: 0.56rem;
            color: #999999;
            margin-bottom: 0.8rem;
          }

          .bg_img2_contact {
            display: flex;
            justify-content: flex-end;

            .bg_img2 {
              background-image: url('../../../assets/home1.png');
              background-size: 100% 100%;
              background-repeat: no-repeat;
              height: 1.6rem;
              width: 1.64rem;
            }

            .bg_img3 {
              background-image: url('../../../assets/home2.png');
              background-size: 100% 100%;
              background-repeat: no-repeat;
              height: 1.68rem;
              width: 1.6rem;
            }

            .bg_img4 {
              background-image: url('../../../assets/home3.png');
              background-size: 100% 100%;
              background-repeat: no-repeat;
              height: 1.68rem;
              width: 1.24rem;
            }

            .bg_img5 {
              background-image: url('../../../assets/home4.png');
              background-size: 100% 100%;
              background-repeat: no-repeat;
              height: 1.68rem;
              width: 1.68rem;
            }

            .bg_img6 {
              background-image: url('../../../assets/home5.png');
              background-size: 100% 100%;
              background-repeat: no-repeat;
              height: 1.6rem;
              width: 1.68rem;
            }

          }
        }
      }

      .question_content_middle {
        display: flex;
        justify-content: space-between;
        margin-bottom: 0.8rem;

        .question_content_middle_inside {
          width: 15%;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0px 0.8rem;

          .arrow {
            width: 1.4rem;
            height: 1.2rem;
            background-image: url('../../../assets/arrow.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
          }
        }
      }

      .question_content_bottom {
        height: 1.6rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #dae2ff;
        color: #4e78ff;
        font-size: 0.56rem;
      }
    }
  }

  .environment {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #F4F3F3;
    padding-bottom: 2.4rem;

    .environment_title {
      margin-top: 1.6rem;
      margin-bottom: 1.6rem;
      font-size: 0.88rem;
      font-weight: 600;
    }

    .environment_contact {
      width: 75%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .environment_contact_inside {
        width: 47%;
        height: 10.2rem;
        margin-bottom: 0.8rem;
        padding: 0.4rem;
        display: flex;

        .left {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 100%;
          margin-right: 2.4rem;
          margin-left: 1.2rem;

          .left_bg {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 4.4rem;
            height: 4.4rem;
            border-radius: 50%;
            background: #fff8f2;

            .left_bg_img1 {
              width: 2.4rem;
              height: 2rem;
              background-image: url('../../../assets/home7.png');
              background-size: 100% 100%;
              background-repeat: no-repeat;
            }

            .left_bg_img2 {
              width: 2.4rem;
              height: 2rem;
              background-image: url('../../../assets/home8.png');
              background-size: 100% 100%;
              background-repeat: no-repeat;
            }

            .left_bg_img3 {
              width: 2.4rem;
              height: 2rem;
              background-image: url('../../../assets/home6.png');
              background-size: 100% 100%;
              background-repeat: no-repeat;
            }

            .left_bg_img4 {
              width: 2.4rem;
              height: 2rem;
              background-image: url('../../../assets/home9.png');
              background-size: 100% 100%;
              background-repeat: no-repeat;
            }
          }
        }

        .right {
          .right_title {
            margin: 0.8rem 0px 0.8rem 0px;
            font-size: 0.72rem;
            font-weight: 600;
          }

          .right_container {
            font-size: 0.56rem;
            color: #999999;
            margin-bottom: 0.2rem;
          }
        }
      }

      .environment_contact_img1 {
        background-image: url('../../../assets/home19.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }

      .environment_contact_img2 {
        background-image: url('../../../assets/home20.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }

      .environment_contact_img3 {
        background-image: url('../../../assets/home21.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }

      .environment_contact_img4 {
        background-image: url('../../../assets/home22.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
    }
  }

  .duiqi {
    display: flex; // 使用 Flexbox 来管理子元素的布局
    align-items: center; // 垂直居中对齐子元素
  }

  .core {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 3.6rem;
    margin-bottom: 3.2rem;

    .duiqi {
      display: flex; // 使用 Flexbox 来管理子元素的布局
      align-items: center; // 垂直居中对齐子元素
    }

    .keleteType {
      width: 105px;
      margin-right: 15px;
    }

    .title {
      margin-bottom: 0.6rem;
      font-size: 0.88rem;
      font-weight: 600;

    }

    .subtitle {
      font-size: 0.56rem;
      color: #999999;
      margin-bottom: 2.4rem
    }

    .core_content {
      width: 80%;
      display: flex;
      justify-content: space-between;

      .inside {
        width: 33%;
        height: 13.6rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .big_img {
          width: 90%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background-image: url('../../../assets/home11.png');
          background-size: 100% 90%;
          background-repeat: no-repeat;


          .bg_small_img {
            // background-image: url('../../../assets/home10.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            width: 35%;
            height: 35%;
          }
        }

        .inside_item {
          height: 32%;
          border-bottom: 0.04rem solid #E5E5E5;
          color: #333333;

          .title {
            font-weight: 600;
            font-size: 0.72rem;
            margin-bottom: 0.4rem;
          }

          .contect {
            font-size: 0.56rem;
          }
        }
      }
    }
  }

  .platform {
    background: #F4F3F3;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 2.4rem;

    .keleteType {
      width: 105px;
      margin-right: 15px;
    }

    .title {
      margin-bottom: 0.6rem;
      font-size: 0.88rem;
      font-weight: 600;
    }

    .subtitle {
      font-size: 0.56rem;
      color: #999999;
      margin-bottom: 2.4rem
    }

    .platform_content {
      width: 80%;
      display: flex;
      justify-content: space-between;
      margin-bottom: 2.4rem;

      .platform_content_item {
        width: 14%;

        .top {
          background: white;
          height: 10.4rem;
          display: flex;
          flex-direction: column;
          align-items: center;

          .bg_img_container {
            height: 40%;
            display: flex;
            align-items: center;
            justify-content: center;

            .bg_img1 {
              width: 1.6rem;
              height: 1.2rem;
              background-image: url('../../../assets/home12.png');
              background-size: 100% 100%;
              background-repeat: no-repeat;
            }

            .bg_img2 {
              width: 1.6rem;
              height: 1.6rem;
              background-image: url('../../../assets/home13.png');
              background-size: 100% 100%;
              background-repeat: no-repeat;
            }

            .bg_img3 {
              width: 2rem;
              height: 1.6rem;
              background-image: url('../../../assets/home14.png');
              background-size: 100% 100%;
              background-repeat: no-repeat;
            }

            .bg_img4 {
              width: 2rem;
              height: 1.6rem;
              background-image: url('../../../assets/home15.png');
              background-size: 100% 100%;
              background-repeat: no-repeat;
            }

            .bg_img5 {
              width: 1.2rem;
              height: 1.6rem;
              background-image: url('../../../assets/home16.png');
              background-size: 100% 100%;
              background-repeat: no-repeat;
            }

            .bg_img6 {
              width: 1.6rem;
              height: 1.6rem;
              background-image: url('../../../assets/home17.png');
              background-size: 100% 100%;
              background-repeat: no-repeat;
            }
          }

          .top_title {
            font-size: 0.8rem;
            font-weight: 600;
            margin-bottom: 0.4rem;
          }

          .top_subtitle {
            font-size: 0.56rem;
            color: #999999;
            margin-bottom: 1.6rem;
          }

          .double_arrow {
            width: 1.6rem;
            height: 0.4rem;
            background-image: url('../../../assets/home23.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
          }
        }
      }

    }

    .curve {
      width: 80%;
      height: 2.4rem;
      background-image: url('../../../assets/home18.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      margin-bottom: 2.8rem;
    }
  }

  .web_mobile {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 2.4rem;
    margin-bottom: 3.2rem;

    .title {
      margin-bottom: 0.6rem;
      font-weight: 500;
      font-size: 4.67rem;
      color: #252E3E;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }

    .subtitle {
      font-size: 0.56rem;
      color: #999999;
    }

    .swiper {
      width: 85%;

      .swiper_img_container {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 150%;

        .swiper_img {
          width: 85%;
          height: 100%;
          background-image: url('../../../assets/home24.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }

      }
    }
  }
}





.container {
  max-width: 1440px;
  margin: 0 auto;
  padding: 2rem 1rem;
}

.menu-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, 132px); // 修改网格列的宽度
  gap: 0.2rem;
  width: 100%;
  padding: 1rem;
  justify-content: start;
}

.menu-item {
  background: white;
  // 这里可以去掉重复的高度设置，因为已经在 style 绑定中设置
  padding: 1.5rem;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  }
}

.menu-content {
  position: relative;
  z-index: 1;
}

.hover-tip {
  color: white; // 提示词颜色
  text-align: center; // 提示词居中显示
  font-size: 16px; // 提示词字体大小
  /* 可以根据需要添加更多样式 */
}

.menu-icon-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.icon-circle {
  width: 3.5rem;
  height: 3.5rem;
  background: linear-gradient(135deg, #3b82f6 0%, #1e3a8a 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
}

.icon {
  font-size: 1.5rem;
  color: white;
}

.menu-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e3a8a;
  margin: 0;
}

.alert-box {
  position: absolute;
  inset: 0;
  background: rgba(59, 130, 246, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 0.5rem;
}

.menu-item:hover .alert-box {
  opacity: 1;
}

.alert-content {
  padding: 1rem;
  color: white;
  text-align: center;
}

.alert-item {
  margin: 0.5rem 0;
  font-size: 0.875rem;
}

@keyframes float {
  0% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(-20px);
  }

  100% {
    transform: translateY(0px);
  }
}

.core-advantages {
  padding: 4rem 0;
  background: #1e293b;
  color: white;

  .section-title {
    text-align: center;
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 3rem;
  }

  .advantages-grid {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 1.5rem;
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 2rem;

    .advantage-card {
      background: rgba(255, 255, 255, 0.1);
      border-radius: 8px;
      padding: 2rem 1rem;
      position: relative;
      transition: all 0.3s ease;
      min-height: 200px;
      display: flex;
      flex-direction: column;
      align-items: center;

      &:hover {
        background: rgba(255, 255, 255, 0.2);
        transform: translateY(-5px);
      }

      .card-number {
        position: absolute;
        top: 1rem;
        left: 1rem;
        font-size: 1.2rem;
        opacity: 0.5;
        font-family: 'Arial', sans-serif;
      }

      .card-icon {
        width: 50px;
        height: 50px;
        margin: 1.5rem 0;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .card-title {
        font-size: 1.1rem;
        text-align: center;
        margin-top: 1rem;
        font-weight: 500;
      }

      &.highlight {
        background: #3b82f6;

        .card-highlight {
          font-size: 0.9rem;
          margin-top: 1rem;
          opacity: 0.8;
          text-align: center;
          line-height: 1.6;
        }
      }
    }
  }
}


</style>
